import { useEffect, useState } from 'react';
import {
  COOKIE_CONSENT_EVENT,
  CookieConsent,
  readCookieConsent,
} from '@/lib/cookieConsent';

export const useCookieConsent = (): CookieConsent => {
  // Wichtig: initial 'unset', damit Server- und Client-Render identisch sind.
  const [consent, setConsent] = useState<CookieConsent>('unset');

  useEffect(() => {
    setConsent(readCookieConsent());
    const updateConsent = () => setConsent(readCookieConsent());
    window.addEventListener(COOKIE_CONSENT_EVENT, updateConsent);
    return () => window.removeEventListener(COOKIE_CONSENT_EVENT, updateConsent);
  }, []);

  return consent;
};
